export enum NotificationStatus {
  DEFAULT = 'information',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}
